// extracted by mini-css-extract-plugin
export default {"root":"BlockWrapper_root__HyGt3","content":"BlockWrapper_content__kSWFv"};